module.exports = __webpack_public_path__ + "static/img/202406.892b4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202406.png
// module id = qBbN
// module chunks = 0